// Local Services Brand Theme
// Professional palette: Deep teal primary + warm gold accent
// Clean, trustworthy look for skilled trades
export const servicesColors = {
    primary: '#1E3A5F', // Deep navy blue (professional, trustworthy)
    primaryLight: '#EBF0F5', // Very light blue background
    primaryDark: '#152A45', // Darker navy
    secondary: '#C7923E', // Warm gold/amber (not orange)
    secondaryLight: '#FDF6E9', // Light warm background
    accent: '#C7923E', // Same as secondary for consistency
    accentLight: '#FDF6E9',
    accentDark: '#A67A2E',
    success: '#2D7D5F', // Forest green
    successLight: '#E8F5EF',
    warning: '#D4A12C', // Amber
    text: '#1A2233', // Very dark blue-gray
    textSecondary: '#4A5568', // Medium slate gray
    textMuted: '#8594A5',
    background: '#F7F9FB', // Clean off-white with blue tint
    bgLight: '#F1F5F8',
    bgWarm: '#FFFBF5',
    border: '#E2E8F0',
    divider: '#E2E8F0',
    cardBg: '#FFFFFF',
    gradient: 'linear-gradient(135deg, #1E3A5F 0%, #2D5078 100%)',
};
